export function getAssignmentStatus(props) {
    const { row, productHandle } = props;
    const allAp = row.assignmentProgressList || [];

    /* Can be "Completed" if
        1. Truly complete in our system
        2. Marked "previously completed" in Manage area
        3. Completed an equivalent course
    */

    if (row['assignmentProgress.completed']) {
        return 'Completed';
    }

    const training = JSON.parse(row['fields.trained'] || {});
    if (training[productHandle]) {
        return 'Completed';
    }

    if (
        productHandle.startsWith('ael') &&
        allAp.some(ap => ap.completed && ap.deployment.deploymentHandle.startsWith('ael_'))
    ) {
        return 'Completed';
    }

    if (
        productHandle === 'ssgrin_k2' &&
        allAp.some(ap => ap.completed && ap.deployment.deploymentHandle === 'ssgrin_35_training')
    ) {
        return 'Completed';
    }

    if (
        productHandle === 'ssgrin_35' &&
        allAp.some(ap => ap.completed && ap.deployment.deploymentHandle === 'ssgrin_k2_training')
    ) {
        return 'Completed';
    }

    if (productHandle.startsWith('ael') && Object.keys(training).some(k => k.startsWith('ael') && training[k])) {
        return 'Completed';
    }

    if (
        (productHandle === 'ssgrin_k2' && training.ssgrin_35) ||
        (productHandle === 'ssgrin_35' && training.ssgrin_k2)
    ) {
        return 'Completed';
    }

    /* IN PROGRESS */
    if (row['assignmentProgress.started']) {
        return 'In Progress';
    }

    /* NOT STARTED */
    return 'Not Started';
}
